import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "register-container" }
const _hoisted_2 = { class: "register-box" }
const _hoisted_3 = {
  key: 0,
  class: "snackbar error top"
}
const _hoisted_4 = {
  key: 1,
  class: "snackbar success top"
}
const _hoisted_5 = { class: "input-group" }
const _hoisted_6 = {
  key: 0,
  class: "error-message"
}
const _hoisted_7 = { class: "input-group" }
const _hoisted_8 = {
  key: 0,
  class: "error-message"
}
const _hoisted_9 = { class: "input-group" }
const _hoisted_10 = { class: "password-container" }
const _hoisted_11 = ["type"]
const _hoisted_12 = {
  key: 0,
  class: "error-message"
}
const _hoisted_13 = { class: "input-group" }
const _hoisted_14 = { class: "password-container" }
const _hoisted_15 = ["type"]
const _hoisted_16 = {
  key: 0,
  class: "error-message"
}
const _hoisted_17 = { class: "show-passwords" }

import { ref } from "vue";
import { useRouter } from "vue-router";
import {
  emailValidation,
  passwordValidation,
  confirmPasswordValidation,
  nameValidation,
} from "@/utils/validations";
import api from "@/services/api";


export default /*@__PURE__*/_defineComponent({
  __name: 'RegisterCard',
  setup(__props) {

const router = useRouter();

// Refs para os campos
const fullName = ref("");
const email = ref("");
const password = ref("");
const confirmPassword = ref("");
const showPasswords = ref(false);

// Erros
const fullNameError = ref("");
const emailError = ref("");
const passwordError = ref("");
const confirmPasswordError = ref("");

// Mensagens
const errorMessage = ref("");
const successMessage = ref("");

// Validações
function validateFullName() {
  const validation = nameValidation(fullName.value);
  fullNameError.value = validation === true ? "" : validation;
}

function validateEmail() {
  const validation = emailValidation(email.value);
  emailError.value = validation === true ? "" : validation;
}

function validatePassword() {
  const validation = passwordValidation(password.value);
  passwordError.value = validation === true ? "" : validation;
}

function validateConfirmPassword() {
  const validation = confirmPasswordValidation(password.value)(
    confirmPassword.value
  );
  confirmPasswordError.value = validation === true ? "" : validation;
}

// Envio do formulário
async function handleSubmit() {
  // Limpa mensagens anteriores
  errorMessage.value = "";
  successMessage.value = "";

  validateFullName();
  validateEmail();
  validatePassword();
  validateConfirmPassword();

  if (
    !fullNameError.value &&
    !emailError.value &&
    !passwordError.value &&
    !confirmPasswordError.value
  ) {
    try {
      const response = await api.post("users/create", {
        name: fullName.value,
        email: email.value,
        password: password.value,
        password2: confirmPassword.value,
      });

      if (response.status === 201) {
        successMessage.value =
          "Cadastro bem-sucedido! Efetue login para continuar.";
        setTimeout(() => {
          router.push("/login");
        }, 1000);
      } else {
        errorMessage.value = "Falha no cadastro. Tente novamente.";
      }
    } catch (error: any) {
      // Pega mensagens de erro específicas
      const apiData = error?.response?.data;

      if (apiData?.email?.[0]) {
        // Erro no campo de e-mail (muito comum em APIs Django/DRF por exemplo)
        errorMessage.value = "Este e-mail já está cadastrado.";
      } else if (
        typeof apiData?.message === "string" &&
        apiData.message.toLowerCase().includes("email")
      ) {
        // Verifica se a mensagem contém "email"
        errorMessage.value = apiData.message;
      } else {
        // Mensagem genérica
        const fallbackError =
          apiData?.message ||
          apiData?.error ||
          apiData?.errors?.[0] ||
          error.message ||
          "Erro desconhecido";

        errorMessage.value = "Erro no cadastro: " + fallbackError;
      }
    }
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[11] || (_cache[11] = _createElementVNode("h1", { class: "register-title" }, "Crie sua conta", -1)),
        _cache[12] || (_cache[12] = _createElementVNode("p", { class: "register-subtitle" }, " Realize apenas alguns passos e comece a explorar todas as funcionalidades do BaOBaH. ", -1)),
        (errorMessage.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(errorMessage.value), 1))
          : _createCommentVNode("", true),
        (successMessage.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(successMessage.value), 1))
          : _createCommentVNode("", true),
        _createElementVNode("form", {
          onSubmit: _withModifiers(handleSubmit, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_5, [
            _cache[5] || (_cache[5] = _createElementVNode("label", { for: "fullName" }, "Nome completo:", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "fullName",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fullName).value = $event)),
              class: _normalizeClass({ 'invalid-input': fullNameError.value }),
              onBlur: validateFullName,
              required: "",
              placeholder: "Seu nome completo"
            }, null, 34), [
              [_vModelText, fullName.value]
            ]),
            (fullNameError.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(fullNameError.value), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[6] || (_cache[6] = _createElementVNode("label", { for: "email" }, "E-mail:", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "email",
              id: "email",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((email).value = $event)),
              class: _normalizeClass({ 'invalid-input': emailError.value }),
              onBlur: validateEmail,
              placeholder: "exemplo@gmail.com"
            }, null, 34), [
              [_vModelText, email.value]
            ]),
            (emailError.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(emailError.value), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[7] || (_cache[7] = _createElementVNode("label", { for: "password" }, "Senha:", -1)),
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                type: showPasswords.value ? 'text' : 'password',
                id: "password",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((password).value = $event)),
                class: _normalizeClass({ 'invalid-input': passwordError.value }),
                onBlur: validatePassword,
                placeholder: "Insira sua senha"
              }, null, 42, _hoisted_11), [
                [_vModelDynamic, password.value]
              ])
            ]),
            (passwordError.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(passwordError.value), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _cache[8] || (_cache[8] = _createElementVNode("label", { for: "confirmPassword" }, "Confirmar senha:", -1)),
            _createElementVNode("div", _hoisted_14, [
              _withDirectives(_createElementVNode("input", {
                type: showPasswords.value ? 'text' : 'password',
                id: "confirmPassword",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((confirmPassword).value = $event)),
                class: _normalizeClass({ 'invalid-input': confirmPasswordError.value }),
                onBlur: validateConfirmPassword,
                placeholder: "Insira sua senha novamente"
              }, null, 42, _hoisted_15), [
                [_vModelDynamic, confirmPassword.value]
              ])
            ]),
            (confirmPasswordError.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(confirmPasswordError.value), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: "showPasswords",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showPasswords).value = $event))
            }, null, 512), [
              [_vModelCheckbox, showPasswords.value]
            ]),
            _cache[9] || (_cache[9] = _createElementVNode("label", { for: "showPasswords" }, "mostrar senhas", -1))
          ]),
          _cache[10] || (_cache[10] = _createElementVNode("button", {
            type: "submit",
            class: "register-button"
          }, "Continuar", -1))
        ], 32),
        _cache[13] || (_cache[13] = _createElementVNode("p", { class: "login-text" }, [
          _createTextVNode(" Já possui uma conta? "),
          _createElementVNode("a", {
            class: "login-link",
            href: "/login"
          }, "Acesse sua conta")
        ], -1))
      ])
    ])
  ]))
}
}

})